<template>
  <w-icon-wrapper icon-name='work-moveable-icon'>
    <path
      id="_84_Bewegungs_Icon"
      data-name="84 Bewegungs_Icon"
      d="M23.994,11.843l-3.9,3.731a1,1,0,0,1-.709.284,1.036,1.036,0,0,1-.741-.3,1,1,0,0,1,.021-1.44l1.358-1.3H13.013v7.016l1.318-1.318a.992.992,0,0,1,1.43,0,1.038,1.038,0,0,1-.01,1.46l-3,3.032a.563.563,0,0,1-.081.081l-.709.71-3.732-3.9a1.008,1.008,0,0,1-.284-.71,1.035,1.035,0,0,1,.305-.74,1,1,0,0,1,1.439.02l1.3,1.359V12.817H3.969l1.358,1.3a1,1,0,0,1,.021,1.44,1.041,1.041,0,0,1-1.45.02l-3.9-3.731.791-.791,3.032-3a1.036,1.036,0,0,1,1.46-.01.993.993,0,0,1,0,1.43L3.959,10.789h7.026V3.772l-1.3,1.359a.994.994,0,0,1-1.439.02A1.04,1.04,0,0,1,8.227,3.7L11.959-.2l.79.79,3,3.032a1.038,1.038,0,0,1,.01,1.46.992.992,0,0,1-1.43,0L13.013,3.762v7.027H20.03L18.711,9.471a.993.993,0,0,1,0-1.43,1.036,1.036,0,0,1,1.46.01l3.032,3a.618.618,0,0,1,.081.081Z"
      transform="translate(0.006 0.202)"
      fill="currentColor"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconMoveable' };
</script>
